<template>
  <v-layout column full-width>
    <v-layout row>
      <h1>Contact Report</h1>

      <v-btn @click="csvExport" color="primary" v-if="users.length > 0">
        Export
        <v-icon>arrow_downward</v-icon>
      </v-btn>
    </v-layout>
    <v-data-table :items="users" :headers="headers" class="elevation-1">
      <template slot="items" slot-scope="{ item }">
        <tr>
          <td>
            {{ item.first_name }}
          </td>
          <td>
            {{ item.last_name }}
          </td>
          <td>
            {{ item.email }}
          </td>
          <td>
            {{ item.phone }}
          </td>
          <td>
            {{ item.display_address }}
          </td>
        </tr>
      </template>
    </v-data-table>
  </v-layout>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { ExportToCsv } from "export-to-csv";
import _ from "lodash";

export default {
  components: {},
  computed: {
    ...mapState("userAuth", ["user"])
  },
  created() {
    this.getReport();
  },
  watch: {},
  data: function() {
    return {
      users: [],
      reportsPending: true,
      headers: [
        { text: "First Name", value: "first_name", sortable: true },
        { text: "Last Name", value: "last_name", sortable: true },
        { text: "Email", value: "email", sortable: true },
        { text: "Phone", value: "phone" },
        { text: "Address", value: "display_address" }
      ]
    };
  },

  methods: {
    getReport() {
      this.$store
        .dispatch("reports/getContactReport")
        .then(users => (this.users = users))
        .catch(err => console.log(err))
        .finally(() => {
          this.reportsPending = false;
        });
    },
    csvExport() {
      const options = {
        fieldSeparator: ",",
        quoteStrings: '"',
        decimalSeparator: ".",
        showLabels: true,
        showTitle: false,
        filename: `contact_report_${this.$moment().format(
          "YYYY-MM-DD_HH-mm-ss"
        )}`,
        useTextFile: false,
        useBom: true,
        useKeysAsHeaders: true
      };

      const usersToExport = this.users.map(user => {
        return _.pick(user, [
          "first_name",
          "last_name",
          "email",
          "phone",
          "display_address"
        ]);
      });

      const csvExporter = new ExportToCsv(options);
      csvExporter.generateCsv(usersToExport);
    }
  }
};
</script>

<style scoped></style>
